import React, { Fragment,useState,useEffect } from 'react';
import {Column,Button} from 'rbx';
import ProvaService from '../../services/prova';
import '../../styles/prova.scss';
import Temporizador from '../shareds/temporizador';
import SpinnerModal from '../shareds/spinner_modal';
import { Confirm } from 'react-st-modal';
import { insProgress } from 'react-ins-progress-bar';
import { Redirect } from "react-router-dom";

function Prova () { 
    let objProva   = localStorage.getItem('dadosProva');
    const jsonProva  = ('retrievedObject: ', JSON.parse(objProva));
    let objQuestao   = localStorage.getItem('dadosQuestao');

    let jsonQuestao  = ('retrievedObject: ', JSON.parse(objQuestao));
    const rows = [1,2,3,4,5,6,7,8,9,10];

    const [questao, setQuestao] = useState(jsonQuestao);
    const [prova, setProva] = useState(jsonProva);
    const [indice, setIndice] = useState(0);
    const [redirectToFim, setRedirectToFim] = useState(false);
    const [previusDisabled, setPreviusDisabled] = useState(true);
    const [nextDisabled, setNextDisabled] = useState(false);
    const [isActive, setisActive] = useState("");
    const [loading, setLoading] = useState(false);
    


    const handlePages = async (parameter) =>{
        insProgress.start()
        if(parameter === 1){
            setNextDisabled(false)
            if(indice >=0){
                let i = indice -1;
                setIndice(i)
                const questao = await ProvaService.questao(jsonProva.id_prova,jsonProva.psprovaalunoquestao[i].cd_questao);
                setQuestao(questao.data)
            }
            if(indice <= 1){
                setPreviusDisabled(true)
            }
         
        }else{
            setPreviusDisabled(false)
            if(indice < jsonProva.psprovaalunoquestao.length-1){
                let i = indice +1;
                setIndice(i)
                //console.log('NEXT>>',i,indice,jsonProva.psprovaalunoquestao.length)
                const questao = await ProvaService.questao(jsonProva.id_prova,jsonProva.psprovaalunoquestao[i].cd_questao);
                setQuestao(questao.data)

                if(i >= jsonProva.psprovaalunoquestao.length-1){
                    setNextDisabled(true)
                }
            }
         
        }
        insProgress.finish()
    }
    
    const selected = async (parameter) => {
        insProgress.start()
        setisActive(parameter)
        // Busca o id da resposta.      
        
        let respostas = jsonProva.psresposta;
        let questoesRespondidas = prova.psprovaalunoquestao;
        
        let arrRespostas =  respostas.filter(function(resposta) {
            return resposta.cd_questao === questao.cd_questao;
        });
        let arrQuestao =  arrRespostas.filter(function(questao) {
            return questao.ds_resposta === parameter;
        });
        let cd_resposta =  arrQuestao[0].cd_resposta;

        let questaoRespondida =  questoesRespondidas.filter(function(resposta) {
            return resposta.cd_questao === questao.cd_questao;
        });

        if(questaoRespondida[0].ds_resposta !== parameter){
            await ProvaService.responder({id_prova: jsonProva.id_prova, cd_questao: questao.cd_questao,cd_resposta: cd_resposta});
            const responseProva   = await ProvaService.prova(jsonProva.id_inscricao);
            localStorage.setItem('dadosProva', JSON.stringify(responseProva.data));   
            setProva(responseProva.data)   
        }         
        insProgress.finish()

    }

    const handlePagesRes = async (parameter) =>{
        if((parameter-1 !== indice)){
            insProgress.start()
            let i = parameter-1;
            setIndice(i)
            const questao = await ProvaService.questao(jsonProva.id_prova,jsonProva.psprovaalunoquestao[i].cd_questao);
            setQuestao(questao.data)
            if(i < 1){
                setPreviusDisabled(true)
            }else{
                setPreviusDisabled(false)
            }
            if(i >= jsonProva.psprovaalunoquestao.length-1){
                setNextDisabled(true)
            }else{
                setNextDisabled(false)
            }
            insProgress.finish()
        }

    }

    const handleFinalizar = async (parameter) =>{
        await ProvaService.finalizarprova({ id_inscricao: prova.id_inscricao, id_prova: prova.id_prova });
        localStorage.removeItem('token');
        localStorage.removeItem('dadosQuestao');
        localStorage.removeItem('dadosProva');
    }

    useEffect(()=> { 
     setQuestao(questao);
     setisActive("")
       
    }, [questao])
 
    if(redirectToFim)    
        return <Redirect to={{pathname: "/vestibular/prova/finalizada"}}/>
      
    return (
        <Fragment>          
            <Column.Group  breakpoint="mobile" className="Body">
                <Column >
                    {loading ? <SpinnerModal/> : ''}
                    <p className="info-prova">{jsonProva.ds_nomealuno}</p>
                    <p className="info-prova-2">PROVA OBJETIVA</p>
                    <p className="info-prova-2">ATENÇÃO: NÃO SE ESQUEÇA DE ENCERRAR A PROVA! </p>
             
                    <Temporizador data={jsonProva.dt_fimprova} status={'TEMPO RESTANTE'}/>
                    
                    <Button  color={"info"} className="button-encerrar"  
                      onClick={async () => {
                          
                        const result = await Confirm('Atenção, ao clicar em "SIM" a prova será encerrada!','Deseja Encerrar a prova?','SIM','NÃO');
                        if (result) {
                            handleFinalizar();
                            setLoading(true);
                            setTimeout(() => {
                                setRedirectToFim(true)   
                                setLoading(false)
                            }, 5000);
                        } else {
                            // Сonfirmation not confirmed
                        }
                        }}
                    >                        
                        ENCERRAR A PROVA
                    </Button>
            
                    <p className="nr-questao">QUESTÃO {indice+1}</p>
                </Column>  
            </Column.Group>  
            <Column.Group  breakpoint="mobile" className="Body">
               <Column size={7}>
                    <img src={`data:image/jpeg;base64,${questao.ds_imagem}`} alt="Questão." />
                </Column>    
                <Column size={5}>
                    <p className="resposta">Respostas</p>
                    {rows.map ((cols) => ( 
                        <div key={cols} className="columns is-mobile gabarito">
                            {prova.psprovaalunoquestao.filter((item, idx) => (idx >= (cols*5)-5) && (idx < cols*5)).map((item, key) =>
                                <div key={key} className="respostas">
                                    <div   className="text-danger" id={(cols*5)-5 + key+1} onClick={() => handlePagesRes((cols*5)-5 + key+1) }>
                                        <a href="#/">
                                            {(cols*5)-5 + key+1}  
                                        </a>
                                    </div>
                                    <div>
                                        <a  href="#/" className="text-white" onClick={() => handlePagesRes((cols*5)-5 + key+1) }>
                                            {item.ds_resposta}
                                        </a>
                                    </div>
                                </div>                                    
                            )}
                        </div>
                    ))}        
                </Column>
            </Column.Group>  
            <Column.Group centered>
                <Column size={7}> 
                    <div className="columns is-mobile button-respostas">
                    <Button id="ra" value="A" className={isActive === '(A)' ? 'button-resposta2': 'button-resposta'}  onClick={() => selected('(A)')}>
                        A
                    </Button>
                    <Button id="rb" value="B" className={isActive === '(B)' ? 'button-resposta2': 'button-resposta'}  onClick={() => selected('(B)')}>
                        B
                    </Button>
                    <Button id="rc" value="C" className={isActive === '(C)' ? 'button-resposta2': 'button-resposta'}  onClick={() => selected('(C)')}>
                        C
                    </Button>
                    <Button id="rd" value="D" className={isActive === '(D)' ? 'button-resposta2': 'button-resposta'}  onClick={() => selected('(D)')}>
                        D
                    </Button>
                    <Button id="re" value="E" className={isActive === '(E)' ? 'button-resposta2': 'button-resposta'}  onClick={() => selected('(E)')} >
                        E
                    </Button>
                    </div>
                </Column>
            </Column.Group>
            <Column  size={6} className="columns is-mobile">
                <Button className="button-pag" id="previus" color={'success'}  onClick={() => handlePages(1)} disabled={previusDisabled?true:""}>
                    Anterior
                </Button>
                <Button  className="button-pag" id="next" color={'success'} onClick={() => handlePages(2) } disabled={nextDisabled?true:""}>
                    Proximo
                </Button>
            </Column>
        </Fragment>
    )
}

export default Prova;